import { Controller } from "@hotwired/stimulus"

// Parent "select all" checkbox that reflects the state of its children.
// See the Checkbox documentation in Lookbook for wiring and usage examples.
export default class extends Controller {
  static targets = ["parent", "child"]

  connect() {
    this.sync()
  }

  childTargetConnected() {
    this.scheduleSync()
  }

  childTargetDisconnected() {
    this.scheduleSync()
  }

  disconnect() {
    cancelAnimationFrame(this._syncFrame)
  }

  toggleAll() {
    const checked = !this.allChecked
    this.childTargets.forEach((child) => {
      child.checked = checked
      this.dispatchChangeEvent(child)
    })
    this.sync()
  }

  // Dispatches a change event so other controllers wired to the child
  // (e.g. bulk-selector) react to programmatic checked changes.
  dispatchChangeEvent(child) {
    child.dispatchEvent(new Event("change", { bubbles: true }))
  }

  // Coalesces rapid-fire calls (e.g. many children connecting at once from
  // a Turbo frame load) into a single sync on the next animation frame.
  scheduleSync() {
    cancelAnimationFrame(this._syncFrame)
    this._syncFrame = requestAnimationFrame(() => this.sync())
  }

  sync() {
    const total = this.childTargets.length
    const checkedCount = this.childTargets.filter((c) => c.checked).length
    const parent = this.parentTarget

    if (checkedCount === 0) {
      parent.checked = false
      parent.indeterminate = false
    } else if (checkedCount === total) {
      parent.checked = true
      parent.indeterminate = false
    } else {
      parent.checked = false
      parent.indeterminate = true
    }
  }

  get allChecked() {
    return this.childTargets.length > 0 &&
      this.childTargets.every((c) => c.checked)
  }
}
